import { colors, fonts } from '@grupoboticario/flora-tokens/toqueto/web/ds'

export const toqueto = {
  colors,
  fonts,
}
